module.exports = __webpack_public_path__ + "static/media/lion.c7716c73.mp3";